import * as action_types from './action_types';
import * as constant from '../shared/constants';
import axios from '../utils/axiosClient';

export const act_GetDivision = (data) => {
  const request = axios.get(
    data === '0'
      ? constant.GetDivision
      : `${constant.GetDivisionByClient}/${data}`
  );
  return {
    type: action_types.GET_DIVISION,
    payload: request,
  };
};

export const act_GetFeeders_By_Assetpoint = (data) => {
  const request = axios.get(`${constant.GetFeederByLocation}/${data}`);
  return {
    type: action_types.GET_FEEDERS_LOCATION,
    payload: request,
  };
};

export const act_GetLocation_Division = (divisionId, userId, clientId) => {
  const request = axios.get(
    `${constant.GetLocationByDivision}/${userId}/${clientId}/${divisionId}`
  );
  return {
    type: action_types.GET_LOCATION_BY_DIVISION,
    payload: request,
  };
};

export const act_GetReliabilityChartsData = (type, id) => {
  const request = axios.get(`${constant.GetReliabilityCharts + type}/${id}`);
  return {
    type: action_types.GET_RELIABILITY_CHARTS,
    payload: request,
  };
};

export const act_GetPhasorChartsData = (data) => {
  const request = axios.get(constant.GetPhasorDiagramData + data);
  return {
    type: action_types.GET_PHASOR_CHARTS,
    payload: request,
  };
};

export const act_GetPhasorInstantaneousData = (data) => {
  const request = axios.get(constant.GetPhasorInstantaneousData + data);
  return {
    type: action_types.GET_PHASOR_INSTANTANEOUS_DATA,
    payload: request,
  };
};

export const act_GetDemandChartsData = (data) => {
  const request = axios.post(constant.GetDemandCharts, data);
  return {
    type: action_types.GET_DEMAND_CHARTS,
    payload: request,
  };
};

export const act_GetFrequencyChartsData = (data) => {
  const request = axios.post(constant.GetFrequencyCharts, data);
  return {
    type: action_types.GET_FREQUENCY_CHARTS,
    payload: request,
  };
};

export const act_GetPeakDemandProfile = (type, id) => {
  const request = axios.get(`${constant.GetPeakDemandProfile}${type}/${id}`);
  return {
    type: action_types.GET_PEAK_DEMAND_PROFILES,
    payload: request,
  };
};

// get SLD data
export const act_GetSLDData = (id) => {
  const request = axios.get(`${constant.GetSLDData}/${id}`);
  return {
    type: action_types.GET_SLD_DATA,
    payload: request,
  };
};

export const act_GetProducts = () => {
  const request = axios.get(`${constant.GetProducts}`);
  return {
    type: action_types.GET_PRODUCTS,
    payload: request,
  };
};

export const act_GetDailyReportByDateAndID = (data) => {
  const request = axios.post(`${constant.GetDailyReportByDateAndID}`, data);
  return {
    type: action_types.GET_DAILY_REPORT_BY_DATE_AND_ID,
    payload: request,
  };
};

export const actGetPrimaryNode = async (userId, clientId) => {
  const request = await axios.get(
    `${constant.GetPrimaryNode}/${userId}/${clientId}`
  );
  return {
    type: action_types.GET_PRIMARY_NODE,
    payload: request.data.result,
  };
};
